<template>
  <div class="docs">
    <div class="container">
      <div class="docs__wrapper">
        <h1 class="docs__title">Privacy Policy</h1>
        <div class="docs__block">
          <h6>1. Information We Collect</h6>
          <p>ALCOR INNOVATIVE LTD S.R.L specializes in developing digital solutions including website creation, design, and software consulting services.  </p>
          <ul>
            <li>Contact details (first name, last name, email, phone number)</li>
            <li>Professional information (company name)</li>
            <li>Technical data (device specifications, operating system, network information)</li>
            <li>Usage data (IP addresses, search queries, cookie data)</li>
          </ul>
          <p>This information may be provided voluntarily by users or collected automatically through website interactions. We use cookies to improve website performance, enable features, and deliver customized content. Your data remains confidential and will not be disclosed to unaffiliated third parties except when legally required.  Providing optional information is always at your discretion and will not limit your access to our services.  </p>
        </div>
        <div class="docs__block">
          <h6>2. How We Use Your Information</h6>
          <p>We process your personal data to:  Deliver and improve our services Respond to customer inquiries and provide support Protect our services from security threats and fraudulent activity Analyze usage patterns to enhance user experience Develop better products and evaluate marketing effectiveness</p>
        </div>
        <div class="docs__block">
          <h6>3. Legal Basis For Data Protection</h6>
          <p>We handle your information for these specific purposes:  Website operation and service delivery Security protection and unauthorized access prevention Customer service and inquiry resolution Usage analytics and traffic monitoring Convenience features for returning visitors Internal business operations Should our data processing purposes change, we will obtain your consent before proceeding. </p>
        </div>
        <div class="docs__block">
          <h6>4. Information Sharing Policy</h6>
          <p>We maintain strict confidentiality of your personal data and will not share it with third parties without your explicit permission.  Exceptions may include:  Service provision requirements Legal compliance obligations Security threat prevention Suspected illegal activity investigations Please note that while we implement security measures, other entities (such as network providers) may monitor online activities.</p>
        </div>
        <div class="docs__block">
          <h6>5. Contact information</h6>
          <p>For complaints regarding the Site or to obtain more information about its usage, please contact us at: <a href="mailto:info@alcorinnovativeltd.com">info@alcorinnovativeltd.com</a>.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style lang="scss" scoped>
.docs {
  padding-block: 200px;

  &__wrapper {
    display: flex;
    flex-direction: column;
    gap: 30px
  }

  &__title {
    color: #2F327D;
    font-size: 50px;
    font-weight: 900;
    line-height: 180%;
    letter-spacing: 1px;
  }

  &__block {
    display: flex;
    flex-direction: column;
    gap: 20px;

    & ul {
      padding-left: 30px;
    }

    & h6 {
      color: #F48C06;
      font-size: 30px;
      font-weight: 900;
      line-height: 180%;
      letter-spacing: 0.6px;
    }

    & p, li {
      color: #000;
      font-size: 18px;
      font-weight: 400;
      line-height: 180%;
      letter-spacing: 0.36px;
    }
  }
}

@media (max-width: 850px) {
  .docs {
    &__title {
      font-size: 36px;
    }

    &__block {
      & h6 {
        font-size: 24px;
      }

      & p, li {
        font-size: 14px;
      }
    }
  }
}
</style>